<template slot-scope="scope">
  <!-- 年度汇算清缴上传 弹窗 -->
  <div>
    <dialogModel
      title="汇算多家"
      width="1200px"
      :visible="VisibleUp"
      @handleClose="handleClose"
      @handleOk="handleConfirm"
    >
      <div class="main-body">
        <div class="section-row">
          <div class="section-block section-left">
            <div class="section-title">企业信息</div>
            <div class="upload-hint">
              企业信息请通过上传模板文件批量填写，无需在此单独选择。
            </div>
          </div>

          <div class="section-block section-right">
            <div class="section-title">支付与上传</div>
            <div class="form-panel">
              <div class="form-row">
                <span class="form-label">支付方式：</span>
                <el-radio-group v-model="payType">
                  <el-radio
                    v-for="item in payTypeArr"
                    :key="'pay-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </div>
              <div class="form-row upload-row">
                <span class="form-label"><span class="required">*</span>上传：</span>
                <div class="upload-box">
                  <ImportRes
                    :url="UploadUrl"
                    :Switch="30"
                    :ChangeParameters="1"
                    :type="15"
                    :ClearAll="ClearAll"
                    @handleOkImport="handleOkImport"
                    @handleClose="handleClose"
                    @handleClearOut="handleClearOut"
                    @upload-status="onUploadStatus"
                  ></ImportRes>
                  <div class="upload-tip">
                    （上传格式为xlsx、xls文件,大小不得超过10M，请先下载模板，按照模板内容进行添加信息）
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dialogModel>
    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :businessIntent="17"
      :queryType="'proxy'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import ImportRes from "../../../ProxyOther/components/IndexCom/ImportRes.vue";
import {
  pay, //支付接口
} from "../../../../../../../../assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../IndexCom/VerificationPwd.vue"; //支付密码验证
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD } from "@/utils/paymentMethods";
export default {
  props: {
    VisibleUp: {},
    InChange: {},
    options1: {}, //平台企业的客户
    enterprise: {}, //平台企业信息
  },
  components: { ImportRes, CommonPayment, VerificationPwd },
  data() {
    return {
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择 //支付方式选择
      alipayForm: ``,
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",
      VisiblePayment: false,
      paymentPassword: true, //支付密码开启/关闭
      VisiblePwd: false, //支付密码验证
      // resList: [
      //   {
      //     businessType: 30,
      //     customerName: "新企业1",
      //     customerCreditCode: "123456789",
      //     customerLegalPerson: "张xx",
      //     customerPhone: "18237742111",
      //     customerCompanyAddress: "河南省南阳市卧龙区",
      //     customerCompanyAddressCode: "411303",
      //     price: "0.10",
      //     reportYear: "2024",
      //     customerTaxType: 1,
      //     customerCompanyType: 0,
      //     remark: "测试",
      //   },
      // ],
      resList: [],
      priceVo: {
        totalAmount: null,
        priceList: [],
      }, //上传资料返回的价格数量
      UploadUrl: "",
      ClearAll: false,
      uploading: false,
    };
  },
  watch: {
    VisibleUp: {
      handler(newSs, old) {
        if (newSs == false) {
          this.resList = [];
          this.ClearAll = true;
        } else {
          this.ClearAll = false;
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    this.UploadUrl = "/global/proxy/annualClearingUpload";
  },
  methods: {
    onUploadStatus(status) {
      this.uploading = !!status;
    },
    //点击已上传文件后方的x
    handleClearOut() {
      this.resList = [];
    },
    // 上传完成
    handleOkImport(res) {
      const data = (res && res.data && res.data.data) || {};
      this.resList = Array.isArray(data.businessDataList)
        ? data.businessDataList
        : Array.isArray(data)
        ? data
        : [];
      this.priceVo.totalAmount =
        data.totalPrice != null ? data.totalPrice : null;
      this.priceVo.priceList = data.priceList || null;
      if (!this.resList.length) {
        this.$tool.PromptBox("error", "上传文件解析为空请重新上传");
        // 仅提示，不清空上传组件，避免先错后对时把新选文件冲掉；再次选择会走替换上传
      }
    },
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseUp");
    },
    // 确认
    handleConfirm() {
      if (this.uploading) {
        this.$tool.PromptBox("warning", "文件上传中，请稍候再确认");
        return;
      }
      if (this.resList.length > 0) {
        if (localStorage.getItem("PaymentPwd") == "false") {
          //没有开启支付密码验证直接调用支付接口
          this.handleUnderstandPwd();
          //没有开启支付密码验证直接弹支付二维码
          // this.VisiblePayment = true;
        } else {
          // 支付密码验证
          this.VisiblePwd = true;
        }
      } else {
        this.$tool.PromptBox(
          "error",
          "请上传符合模板格式的.xlsx或.xls文件且文件内容不能为空"
        );
      }
    },
    // 支付密码确认 正确
    handleUnderstandPwd(pwd) {
      var data = {
        data: {
          businessType: "ANNUAL_CLEARING",
          payMethod: this.payType,
          password: pwd,
          businessInfo: {
            businessData: this.resList,
          },
        },
      };

      pay(data).then((res) => {
        if (res.code == 0) {
          this.VisiblePwd = false;
          this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage;
          this.totalAmount = res.data.totalAmount;
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;

          this.VisiblePayment = true;
          // this.$emit("handleConfirmUp");
        } else {
          this.VisiblePwd = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../bookkeeping-form-dialog.less";
</style>
